import "./index.css";
import type { IEmptyStateProps, IEmptyStateSizeMap } from "./types";
import { clsx } from "clsx";
import { Button } from "../Button/Button";
import { Typography } from "../Typography";

export const EmptyState = ({
  icon,
  title,
  text,
  buttonProps,
  secondButtonProps,
  className,
  size = "sm",
}: IEmptyStateProps) => {
  const rootClass: string = clsx(
    "nuco-emptyState",
    `nuco-emptyState--${size}`,
    icon && `nuco-emptyState--withIcon`,
    className,
  );

  const sizeMap: IEmptyStateSizeMap = {
    xs: {
      title: {
        variant: "body",
      },
      text: {
        variant: "body",
      },
      button: {
        size: "xs",
      },
    },
    sm: {
      title: {
        variant: "headline",
      },
      text: {
        variant: "headline",
      },
      button: {
        size: "sm",
      },
    },
    md: {
      title: {
        variant: "h4",
      },
      text: {
        variant: "h4",
      },
      button: {
        size: "sm",
      },
    },
    lg: {
      title: {
        variant: "h3",
      },
      text: {
        variant: "h3",
      },
      button: {
        size: "md",
      },
    },
  };

  return (
    <div className={rootClass}>
      <div className="nuco-emptyState__inner">
        {!!icon && (
          <div className="nuco-emptyState__illustration" role="presentation">
            {icon}
          </div>
        )}
        {!!title && (
          <Typography
            className="nuco-emptyState__heading"
            as="h3"
            variant={sizeMap[size].title.variant}
            weight="bold"
            text={title}
          />
        )}
        {!!text && (
          <Typography
            className="nuco-emptyState__text"
            as="p"
            variant={sizeMap[size].text.variant}
            text={text}
          />
        )}
        {!!buttonProps && (
          <div className="nuco-emptyState__actions">
            {secondButtonProps && (
              <Button {...sizeMap[size].button} {...secondButtonProps} />
            )}
            <Button {...sizeMap[size].button} {...buttonProps} />
          </div>
        )}
      </div>
    </div>
  );
};
